"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcademyItem = void 0;
const react_1 = __importDefault(require("react"));
const react_query_1 = require("react-query");
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const common_1 = require("../../../common");
const server_1 = require("../../../server");
const academy_1 = require("../../../server/academy");
const action_1 = require("../../menu/action");
const ui_1 = require("../ui");
const MEMBER_HEAD_TITLE_LIST = [
    { title: 'idf', space: 1 },
    { title: 'name', space: 1 },
    { title: 'className', space: 1 },
    { title: 'privacyConsent', space: 1 },
];
const MEMBER_READ_DATA_KEYS = [
    { title: 'member_idf', space: 1 },
    { title: 'member_name', space: 1 },
    { title: 'class_name', space: 1 },
    { title: 'privacy_consent', space: 1 },
];
const AcademyMemberList = react_1.default.memo(({ academy_id }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [page, setPage] = react_1.default.useState(0);
    const [totalCount, setTotalCount] = react_1.default.useState(0);
    const [listData, setListData] = react_1.default.useState([]);
    const [searchOption, setSearchOption] = react_1.default.useState('');
    const countRef = react_1.default.useRef(10);
    const { data, refetch } = (0, academy_1.useAcademyMembers)(academy_id, {
        ...(searchOption ? { member: searchOption } : {}),
        offset: page * countRef.current,
        limit: countRef.current,
    });
    react_1.default.useEffect(() => {
        if (academy_id)
            refetch();
    }, [academy_id, page, searchOption]);
    react_1.default.useEffect(() => {
        setPage(0);
    }, [searchOption]);
    react_1.default.useEffect(() => {
        if (data) {
            const { total_count, items } = data;
            if (items && items.length > 0) {
                setListData(items);
                setTotalCount(total_count);
                return;
            }
        }
        setListData([]);
        setTotalCount(0);
    }, [data]);
    const renderTitle = react_1.default.useMemo(() => (react_1.default.createElement("div", { className: "table-title" },
        react_1.default.createElement("div", { className: "left-wrap" },
            react_1.default.createElement("p", { className: "title" },
                "\uC18C\uC18D \uD559\uC0DD(",
                totalCount.toString().padStart(2, '0'),
                "\uBA85)")),
        react_1.default.createElement("div", { className: "right-wrap" },
            react_1.default.createElement(ui_1.SearchInput, { defaultValue: searchOption, setSearchOption: setSearchOption })))), [totalCount, searchOption]);
    const renderEmpty = react_1.default.useMemo(() => totalCount <= 0 && (react_1.default.createElement("div", { className: "empty_data" },
        react_1.default.createElement("p", null, "\uB4F1\uB85D\uB41C \uD559\uC0DD\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."))), [totalCount]);
    const renderItem = (item) => {
        if (!item)
            return;
        return MEMBER_READ_DATA_KEYS.map((headItem, idx) => (react_1.default.createElement("div", { key: idx, className: "table-item member-item", style: {
                flex: headItem.space,
                justifyContent: 'flex-start',
                alignItems: 'center',
                display: 'flex',
                overflow: 'hidden',
            } }, headItem.title === 'privacy_consent' ? (react_1.default.createElement("p", { className: "overText2" }, item[headItem.title] ? t('academy.consentYes') : t('academy.consentNo'))) : (react_1.default.createElement("p", { className: "overText2" }, item[headItem.title])))));
    };
    return (react_1.default.createElement(common_1.Table, { className: "table-admin", isInnerPage: true, isInfinite: false, page: page, data: listData, totalCount: totalCount, headTitleList: MEMBER_HEAD_TITLE_LIST, renderTitle: renderTitle, renderItem: renderItem, renderEmpty: renderEmpty, handlerMoreData: (p) => setPage(p) }));
});
exports.AcademyItem = react_1.default.memo(({ academy_id, isModify }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const postAcademyMutation = (0, react_query_1.useMutation)(academy_1.postAcademyAdmin);
    const { data: memberData, refetch: refetchMember } = (0, server_1.useMemberInfo)(!isModify && academy_id ? { id: academy_id } : undefined);
    const detailItem = memberData?.items?.[0];
    const [identifierValue, setIdentifierValue] = react_1.default.useState('');
    const [nicknameValue, setNicknameValue] = react_1.default.useState('');
    const [password, setPassword] = react_1.default.useState('');
    const [passwordConfirm, setPasswordConfirm] = react_1.default.useState('');
    const [phoneNumber, setPhoneNumber] = react_1.default.useState('');
    const [isIdentifierChecked, setIsIdentifierChecked] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        if (!isModify && academy_id)
            refetchMember();
    }, [academy_id, isModify]);
    const cancelMenu = () => {
        dispatch((0, action_1.goToPrevMenu)());
    };
    const handlerSubmit = async () => {
        if (!isIdentifierChecked) {
            alert(t('academy.alert.identifierCheckRequired'));
            return;
        }
        if (password !== passwordConfirm) {
            alert(t('academy.alert.passwordMismatch'));
            return;
        }
        if (phoneNumber && !/^\d+$/.test(phoneNumber)) {
            alert(t('academy.alert.phoneNumberInvalid'));
            return;
        }
        APP.eventManager.publish('SHOW_LOADING', true);
        try {
            await postAcademyMutation.mutateAsync({
                identifier: identifierValue,
                nickname: nicknameValue,
                password,
                phone_number: phoneNumber,
                tenant_id: '', // TODO: 백엔드 확인 후 출처 결정
            });
            APP.eventManager.publish('CHANGE_MENU', {
                showDepth: 'list',
                props: undefined,
            });
        }
        catch (error) {
            alert(error);
        }
        finally {
            APP.eventManager.publish('SHOW_LOADING', false);
        }
    };
    return (react_1.default.createElement("div", { className: "regist_container" },
        react_1.default.createElement("form", { onSubmit: (e) => e.preventDefault() },
            react_1.default.createElement("div", { className: "regist_box_wrapper half" },
                react_1.default.createElement("div", { className: "regist_box" },
                    react_1.default.createElement(ui_1.TextInput, { title: t('academy.field.identifier'), defaultValue: isModify ? identifierValue : (detailItem?.identifier || ''), handlerUpdate: (value) => {
                            setIdentifierValue(value);
                            setIsIdentifierChecked(false);
                        }, disabled: !isModify, noShowButtonArea: !isModify, autoComplete: "username", className: isModify && identifierValue
                            ? isIdentifierChecked ? 'ok' : 'error'
                            : '', buttonOption: isModify && {
                            title: t('academy.button.duplicateCheck'),
                            className: 'btn-semi-round btn-blue btn-xmd',
                            handlerClick: () => {
                                (0, academy_1.getAcademiesList)({ member: identifierValue }).then((response) => {
                                    const { items } = response.result;
                                    const exactMatch = items?.some((item) => item.identifier === identifierValue);
                                    if (exactMatch) {
                                        alert(t('academy.alert.identifierDuplicate'));
                                        setIsIdentifierChecked(false);
                                    }
                                    else {
                                        alert(t('academy.alert.identifierAvailable'));
                                        setIsIdentifierChecked(true);
                                    }
                                });
                            },
                        } }),
                    react_1.default.createElement(ui_1.TextInput, { title: t('academy.field.nickname'), defaultValue: isModify ? nicknameValue : (detailItem?.nickname || ''), handlerUpdate: setNicknameValue, disabled: !isModify, noShowButtonArea: !isModify }),
                    isModify && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(ui_1.TextInput, { title: t('academy.field.password'), type: "password", defaultValue: password, handlerUpdate: setPassword, autoComplete: "new-password" }),
                        react_1.default.createElement(ui_1.TextInput, { title: t('academy.field.passwordConfirm'), type: "password", defaultValue: passwordConfirm, handlerUpdate: setPasswordConfirm, autoComplete: "new-password", className: passwordConfirm
                                ? password === passwordConfirm ? 'ok' : 'error'
                                : '' }))),
                    react_1.default.createElement(ui_1.TextInput, { title: t('academy.field.phoneNumber'), defaultValue: isModify ? phoneNumber : (detailItem?.phone_number || ''), handlerUpdate: setPhoneNumber, disabled: !isModify, noShowButtonArea: !isModify }),
                    react_1.default.createElement("div", { className: "btn-container", style: { width: '100%' } },
                        isModify && (react_1.default.createElement(common_1.Button, { text: t('academy.button.register'), className: "btn-default-round btn-blue btn-xmd", onClick: handlerSubmit })),
                        react_1.default.createElement(common_1.Button, { text: t('academy.button.cancel'), className: "btn-default-round btn-grey btn-xmd", onClick: cancelMenu }))),
                !isModify && academy_id && (react_1.default.createElement("div", { className: "regist_box", style: { gap: 12 } },
                    react_1.default.createElement(AcademyMemberList, { academy_id: academy_id })))))));
});
